var _style, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgHrapiPodcastLogoWhite(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 600 400",
    style: {
      enableBackground: "new 0 0 600 400"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{fill:#FFFFFF;}\n")), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "st0",
    points: "214.7,146.1 187.6,150.7 188.3,114.6 163,119 161.2,211.6 186.5,207.2 187.3,171.4 214.3,166.7  213.6,202.5 238.8,198.2 240.6,105.6 215.4,109.9  "
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M326.8,121.1c0.3-5.9-1.1-11.5-4.2-16.1c-5.8-8.6-17.4-10.7-31.7-8.2l-34.5,6l-1.9,92.8l25.2-4.4l0.6-32.4 l3.2-0.6l19.1,29l28.2-4.9l-23.8-32.1C319.7,143.5,326.2,132.1,326.8,121.1z M290,137.3l-10.1,1.8l0.5-20.4l10.1-1.8 c6.9-1.2,10.7,2.4,11.4,6.6C302.9,128.9,298.9,135.8,290,137.3z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M373.5,89.2l-32.8,91.6l24.7-4.3l7.3-22.1l29-5l6.9,19.6l24.8-4.3L403.7,84L373.5,89.2z M379.2,134.1 l6.1-19.4l2.5-12.4l0.9-0.2l2.1,11.5l5,17.5L379.2,134.1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M472.1,73l-30.3,5.2l-1.7,85.4l22.9-4l0.5-24.2l7.5-1.3c22.6-3.9,34.6-21,35.2-36.2 C506.8,82.5,495.8,69,472.1,73z M471.3,116.9l-7.8,1.3l0.5-25.7l7.8-1.3c8.4-1.5,12.3,4.3,12,10.8 C483.6,108.4,479.3,115.5,471.3,116.9z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st0",
    points: "519.8,149.8 542.9,145.8 544.6,60 521.5,64.1  "
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M562.1,16.5L39.5,107.4v21.9l-22.3,4v101.6l7.8,6l14.5-2.5v10.5l20.2,15.5l394.7-66.8l97.7,14.1l0.1-32.6 l30.1-5.6V32L562.1,16.5z M41.2,163.5l10.3-1.9L51,176.1l12.4-2.2l0.4-14.5l10.3-1.9l-1.2,39.9l-10.3,1.9l0.4-16.2l-12.4,2.2 l-0.4,16.2L40,203.4L41.2,163.5z M577.1,169.2l-30.1,5.6l-0.1,31l-92.6-13.4L61,259l-16.4-12.6v-8.8l46.2-7.9l37.9,5.5l0-12.7 l11.7-2.2V118.7l-7.8-6l-88,15.8v-16.7l516.1-89.8l16.4,12.6V169.2z M107.1,166.8l-0.2,8.5l-14.1,2.6l-0.2,7.5l17.2-3.1l-0.2,8.5 l-27.2,4.9l1.2-39.9l26.2-4.7l-0.2,8.5l-16.2,2.9l-0.2,6.8L107.1,166.8z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M172.6,257.3v87.5l16.5,12.6l26.7-4.9l-0.3,26.2l62-36.3L431.7,314v-97.5l-16.5-2.6L172.6,257.3z  M427.5,310.5L275.7,339l-55.4,31.6l-0.1-23.5l-30.2,5.9l-13.4-10.3v-81.9l237.3-42.5l13.4,2.2V310.5z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M207.7,287.6l-11.2,2.1l-0.3,31.6l8.4-1.5l0.1-8.9l2.8-0.5c8.3-1.5,12.7-7.9,12.9-13.5 C220.5,291,216.4,286,207.7,287.6z M207.5,303.8l-2.9,0.5l0.1-9.5l2.9-0.5c3.1-0.6,4.5,1.6,4.5,3.9 C212,300.7,210.5,303.3,207.5,303.8z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M241.3,280.9c-10.6,2-19.4,11.3-17.4,22.2c1.5,8.1,8.7,12.1,17.1,10.5c10.6-1.9,19.3-11.2,17.3-22.1 C256.9,283.6,249.6,279.4,241.3,280.9z M241,306.3c-3.8,0.7-7.7-1-8.6-5.8c-1.3-6.8,3.5-11.5,8.7-12.4c3.8-0.7,7.7,0.7,8.6,5.7 C251.2,301.6,246,305.4,241,306.3z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M274.8,275.1l-11.5,2.1L263,309l11.5-2.1c12.9-2.4,18.7-13,17.1-21.5C290.4,278.7,284.8,273.2,274.8,275.1z  M274.6,299.9l-3,0.5l0.2-18l3-0.6c4.9-0.8,7.7,2.4,8.4,6C284,292.7,281.2,298.7,274.6,299.9z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M321.3,287.5c-2.7,3.7-6.1,5.3-8.6,5.8c-4.9,0.9-7.9-2-8.7-5.9c-1-5.2,2.3-11.2,8.8-12.5 c2.4-0.5,5.2-0.1,8.1,2.1l5.1-5.4c-4-3.9-8.2-4.8-13.1-3.8c-12.7,2.3-18.9,13.2-17.3,22.2c1.3,7,7.1,12.4,17,10.6 c5.5-1,9.8-4.1,14-9.7L321.3,287.5z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M338.3,263.3l-11.8,34l9.1-1.7l2.6-8.2l10.7-2l2.6,7.2l9.2-1.7l-11.3-29.8L338.3,263.3z M340.5,279.9 l2.2-7.2l0.9-4.6l0.3-0.1l0.8,4.3l1.9,6.4L340.5,279.9z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M375,268.6c-1.6-0.1-4-0.3-3.9-2.1c0.1-1.7,1.6-2.7,3.4-3c1.9-0.4,3.3,0.1,4.6,1.5l5.6-4.3 c-2.5-3.7-6.5-4.8-10.5-4.1c-5.4,1-11.3,4.7-11.5,11.4c-0.2,6.7,6.6,7.7,10.1,7.9l0,0c2,0.1,4.4,0.6,4.2,3 c-0.1,1.5-1.4,2.9-3.4,3.2c-1.5,0.3-4,0.5-6.4-2.3l-5.6,4.8c3,4.7,8.1,5.3,11.8,4.6c5.6-1,11.7-5,12.1-11.5 C385.9,270.3,380.3,268.9,375,268.6z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st0",
    points: "387,261.6 394.7,260.2 394.5,284.8 403,283.2 403.3,258.6 411.1,257.2 411.1,250.2 387,254.7  "
  }))))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgHrapiPodcastLogoWhite);
export default __webpack_public_path__ + "static/media/HRAPI_podcast-logo_white.6a8169bc4f7aa221bf76217107134e08.svg";
export { ForwardRef as ReactComponent };